const initWooTablist = (el) => {
  const $el = $(el);

  const tabList = $el.find(".js-tab-categories-buttons");
  const $activeTab =  tabList.find('.js-tablist-category-button[aria-selected="true"]');

  if ($activeTab.length) {
    const containerScrollLeft = $(tabList).scrollLeft();
    const containerWidth = $(tabList).outerWidth();
    const tabOffsetLeft = $activeTab.position().left;
    const tabWidth = $activeTab.outerWidth();

    const scrollTo = containerScrollLeft + tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);

    $(tabList).animate({ scrollLeft: scrollTo }, 400);
  }
};

export default initWooTablist;
